import { memoize } from 'lodash';
import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';
export var getBiLoggerInstance = memoize(function (biSchema, Wix) {
    var factory = iframeAppBiLoggerFactory(Wix);
    return biSchema(factory)();
});
//# sourceMappingURL=index.js.map